import { casingUtil } from '@/utils'
import { ServerTipalti, Tipalti } from './types'

export const resolveTipaltiDown = (tipalti: ServerTipalti) => {
  return casingUtil.snakeToCamel(tipalti) as Tipalti
}
